module.exports = __webpack_public_path__ + "img/home_23.bbf40cbb.png";